import { CountryCode } from '../types';
// todo: remove wildcard when all envs are set up
export const ALLOWED_PORTAL_URLS = (process.env.REACT_APP_PORTAL_URL || '*').split(',');
export const IS_ON_IFRAME = window.parent !== window;
export const SSO_URL = process.env.REACT_APP_AUTH_API_REDIRECT_URI || '';
export const VERSION = process.env.REACT_APP_VERSION || '';
export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || '';
export const COUNTRY_MAP = {
    [CountryCode.MONTENEGRO]: 'Montenegro',
    [CountryCode.GERMANY]: 'Germany',
    [CountryCode.SPAIN]: 'Spain',
    [CountryCode.GEORGIA]: 'Georgia',
    [CountryCode.CROATIA]: 'Croatia',
    [CountryCode.NETHERLANDS]: 'Netherlands',
    [CountryCode.POLAND]: 'Poland',
    [CountryCode.TURKEY]: 'Turkey',
    [CountryCode.UZBEKISTAN]: 'Uzbekistan',
    [CountryCode.COLOMBIA]: 'Colombia',
    [CountryCode.LITHUANIA]: 'Lithuania',
    [CountryCode.MEXICO]: 'Mexico',
    [CountryCode.UKRAINE]: 'Ukraine',
    [CountryCode.KAZAKHSTAN]: 'Kazakhstan',
    [CountryCode.SERBIA]: 'Serbia',
    [CountryCode.ARMENIA]: 'Armenia',
    [CountryCode.INDIA]: 'India',
};
